import en from './en.json';

// TODO: add more languages
export const LANGUAGES = ['en'];
export const DEFAULT_LANGUAGE = 'en';

const translations = { en };
export default translations;
